import React from 'react';
import type { ReactNode } from 'react';
import { getFeatureByName, getSupportedTraits } from './getters';
import type { Feature } from './types';

type RenderWithTraits = (traits: ImmutableArray<string>) => ReactNode;

interface Props {
  readonly allFeatures: ImmutableArray<Feature>;
  readonly wanted: string;
  readonly children: ReactNode | RenderWithTraits;
}

export function IfFeature({ allFeatures, wanted, children }: Props): ReactNode {
  const feature = getFeatureByName(allFeatures, wanted);

  if (!feature) return null;

  return (
    <>
      {typeof children === 'function' ? children(getSupportedTraits(feature)) : children}
    </>
  );
}
